/**
 * CX Countdown: updates hours, minutes, seconds from data-countdown-end on the timer element.
 * End date format: "YYYY-MM-DD HH:mm:ss" or "YYYY-MM-DDTHH:mm:ss"
 */
(function () {
  const pad = (n) => String(Math.max(0, Math.floor(n))).padStart(2, '0');

  function renderDigits(el, paddedStr) {
    if (!el || typeof paddedStr !== 'string') return;
    el.textContent = '';
    for (let i = 0; i < paddedStr.length; i += 1) {
      const span = document.createElement('span');
      span.className = 'cx-countdown__digit';
      span.textContent = paddedStr[i];
      el.appendChild(span);
    }
  }

  function getRemaining(endDate) {
    const now = Date.now();
    const end = endDate.getTime();
    const diff = end - now;
    if (diff <= 0) return { hours: 0, minutes: 0, seconds: 0 };
    const hours = diff / (1000 * 60 * 60);
    const minutes = (diff / (1000 * 60)) % 60;
    const seconds = (diff / 1000) % 60;
    return { hours, minutes, seconds };
  }

  function parseEndDate(value) {
    if (!value || typeof value !== 'string') return null;
    const s = value.trim().replace(' ', 'T');
    const d = new Date(s);
    return Number.isNaN(d.getTime()) ? null : d;
  }

  const COUNTDOWN_INITED = 'data-countdown-inited';

  function unitWord(n, singular, plural) {
    const v = Math.floor(Math.max(0, n));
    return `${v} ${v === 1 ? singular : plural}`;
  }

  function updateAriaLabel(container, r, baseLabel) {
    const root = container.closest('[data-cx-countdown]');
    if (!root || root.getAttribute('data-unit-labels') !== 'false') return;
    const h = Math.floor(Math.max(0, r.hours));
    const m = Math.floor(Math.max(0, r.minutes));
    const s = Math.floor(Math.max(0, r.seconds));
    const parts = [unitWord(h, 'hour', 'hours'), unitWord(m, 'minute', 'minutes'), unitWord(s, 'second', 'seconds')];
    container.setAttribute('aria-label', `${baseLabel} ${parts.join(', ')}`);
  }

  function updateTimer(container) {
    if (container.hasAttribute(COUNTDOWN_INITED)) return;
    container.setAttribute(COUNTDOWN_INITED, 'true');

    const endAttr = container.getAttribute('data-countdown-end');
    const endDate = parseEndDate(endAttr);
    const hoursEl = container.querySelector('[data-countdown-hours]');
    const minutesEl = container.querySelector('[data-countdown-minutes]');
    const secondsEl = container.querySelector('[data-countdown-seconds]');
    const baseAriaLabel = container.getAttribute('aria-label') || 'Time remaining';

    if (!hoursEl || !minutesEl || !secondsEl) return;

    if (!endDate) {
      renderDigits(hoursEl, '00');
      renderDigits(minutesEl, '00');
      renderDigits(secondsEl, '00');
      updateAriaLabel(container, { hours: 0, minutes: 0, seconds: 0 }, baseAriaLabel);
      return;
    }

    const set = () => {
      const r = getRemaining(endDate);
      renderDigits(hoursEl, pad(r.hours));
      renderDigits(minutesEl, pad(r.minutes));
      renderDigits(secondsEl, pad(r.seconds));
      updateAriaLabel(container, r, baseAriaLabel);
    };

    set();
    if (window.Shopify?.designMode) return;
    const interval = setInterval(() => {
      const r = getRemaining(endDate);
      renderDigits(hoursEl, pad(r.hours));
      renderDigits(minutesEl, pad(r.minutes));
      renderDigits(secondsEl, pad(r.seconds));
      updateAriaLabel(container, r, baseAriaLabel);
      if (r.hours <= 0 && r.minutes <= 0 && r.seconds <= 0) clearInterval(interval);
    }, 1000);
  }

  function init() {
    const containers = document.querySelectorAll('[data-countdown-end]');
    for (const el of containers) {
      updateTimer(el);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
